import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SexoService } from './entity-sexo.service';
import {
  entitySexosLoadFailure,
  entitySexosLoadRequest,
  entitySexosLoadSuccess
} from './entity-sexo.actions';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  entityPersonasAddSuccess,
  entityPersonasChangeSuccess
} from '../entity-personas/entity-personas.actions';

@Injectable()
export class SexoEffect {
  constructor(private actions$: Actions, private sexoService: SexoService) {}

  loadRequestSexo = createEffect(() =>
    this.actions$.pipe(
      ofType(entitySexosLoadRequest, entityPersonasChangeSuccess),
      mergeMap(() =>
        this.sexoService.getAll().pipe(
          map((items) => entitySexosLoadSuccess({ items })),
          catchError((error) => of(entitySexosLoadFailure({ error })))
        )
      )
    )
  );

  addRequestSexo = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasChangeSuccess, entityPersonasAddSuccess),
      switchMap(() => {
        return this.sexoService.getAll().pipe(
          map((items) => {
            return entitySexosLoadSuccess({ items });
          }),
          catchError((error) => of(entitySexosLoadFailure({ error })))
        );
      })
    )
  );

  loadRequestSexoSuccess = createEffect(
    () => this.actions$.pipe(ofType(entitySexosLoadSuccess)),
    { dispatch: false }
  );
}
